export class UserPreferences
{
	quotation_list_default_progresses: string[];
}